<app-inline-spinner [isVisible]="!(subs$ | async)?.closed" style="display: block; text-align: center;"></app-inline-spinner>
<div class="no-results" *ngIf="(subs$ | async)?.closed && callLogs && callLogs.length === 0">
    <p>No call records for the customer</p>
</div>
<ng-container *ngIf="(subs$ | async)?.closed && callLogs && callLogs.length > 0">
    <table class="table table-borderless table-hover align-middle">
        <thead class="thead-white">
        <tr>
            <th class="text-primary fs-5 fw-600 text-nowrap" title="Direction">In/Out</th>
            <th class="text-primary fs-5 fw-600 text-nowrap">Duration</th>
            <th class="text-primary fs-5 fw-600 text-nowrap">Date</th>
            <th class="text-primary fs-5 fw-600 text-nowrap">To</th>
            <th class="text-primary fs-5 fw-600 text-nowrap">From</th>
            <th class="text-primary fs-5 fw-600 text-nowrap"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let callHist of callLogs" class="toplined call-log-row {{callHist.status}}">
            <td title="Direction/Duration">
                <i class="fa" [ngClass]="{'fa-reply': callHist.direction == 'out', 'fa-share': callHist.direction == 'in'}"></i>
            </td>
            <td>{{ callHist.duration | duration }}</td>
            <td>{{ callHist.createdAt | date: 'dd MMM yyyy HH:mm' }}</td>
            <td>{{ (callHist.direction === 'out' ? callHist.callFrom : callHist.callTo) | replace: ' ' : '' | match:'(\\+?\\d+)':"gi" | head |  formatPhone }}</td>
            <td>{{ (callHist.direction === 'out' ? callHist.callTo : callHist.callFrom) | replace: ' ' : '' | match:'(\\+?\\d+)':"gi" | head | formatPhone }}</td>
            <td class="d-flex">
                <div class="playback me-2">
                    <i class="fas fa-play-circle" [@fadeIn] [@fadeOut] *ngIf="playing != callHist.sId && callHist.mediaFile" [style.font-size]="'30px'" (click)="initPlaybackRecord(callHist)"></i>
                    <i class="fas fa-stop-circle" [@fadeIn] [@fadeOut] *ngIf="playing == callHist.sId && callHist.mediaFile" [style.font-size]="'30px'" (click)="stopPlayback()"></i>
                </div>
                <svg-icon class="me-2 hover" src="assets/images/call/phone-handset.svg" (click)="makeACallLog(callHist)"></svg-icon>
                <div appDropdown class="dropdown ys-dropdown-menu ms-3">
                        <span class="hover" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <svg-icon src="assets/images/icon-menu-action.svg"></svg-icon>
                        </span>
                    <div class="dropdown-menu dropdown-menu-end shadow-sm p-0 g-0">
                            <span class="dropdown-item text-primary py-2 disabled">
                                Add to contacts
                            </span>
                        <span class="dropdown-item text-primary py-2 disabled">
                                Copy data
                            </span>
                        <span class="dropdown-item text-primary py-2 disabled">
                                Another menu
                            </span>
                    </div>
                </div>
            </td>
        </tr>
        </tbody>
    </table>

    <app-pagination [params]="callParams" (update)="callHistoryList()"></app-pagination>
</ng-container>
